<template>
  <div>
    <v-app-bar
    clipped-left
    app
    color="white"
    dark
    height="79.75"
    elevation="1"
    class="admin-header-vue"
    v-if="$vuetify.breakpoint.lgAndUp == false"
    >

      <v-row class="px-5">

        <div class="d-flex align-center">

          <v-img
          class="shrink"
          contain
          src="@/assets/Mygems_logo.png"
          transition="scale-transition"
          width="150"
          />

          <!-- <h2>MyGEMS</h2> -->

        </div>

        <v-spacer></v-spacer>

        <v-btn icon>
          <v-icon large @click="backToLandingPage">mdi-home</v-icon>
        </v-btn>

        <v-btn icon>
          <v-icon large @click="logout">mdi-logout</v-icon>
        </v-btn>
        
        <v-btn icon>
          <v-icon large @click="openMenuAdmin">mdi-menu</v-icon>
        </v-btn>
        
      </v-row>

    </v-app-bar>

    <v-navigation-drawer
    style="z-index: 10"
    v-model="drawerMobileMenu"
    app
    bottom
    height="auto"
    class="background-mobile-menu-panel"
    v-if="$vuetify.breakpoint.mdAndDown"
    >
      <v-list
      nav
      dense
      >

        <v-list-item
        v-for="item in items"
        :key="item.title"
        link
        :to="item.url"
        :class="$route.path.toUpperCase() == item.url.toUpperCase()? 'left-panel-button' : ''"
        >
          
          <v-badge
          v-if="item.url == '/PengurusanPengguna' && notiPengurusanPengguna != 0"
          class="pa-0 mx-0"
          color="red"
          :content="notiPengurusanPengguna"
          >
            <v-icon class="white--text">{{ item.icon }}</v-icon>
          </v-badge>

          <v-badge
          v-else-if="item.url == '/PengurusanAduan' && notiPengurusanAduan != 0"
          class="pa-0 mx-0"
          color="red"
          :content="notiPengurusanAduan"
          >
            <v-icon class="white--text">{{ item.icon }}</v-icon>
          </v-badge>

          <v-icon v-else class="white--text">{{ item.icon }}</v-icon>

          <v-list-item-content>
            <v-list-item-title class="white--text text-body-1">
              <span class="ml-6">{{ item.title }}</span>
            </v-list-item-title>
          </v-list-item-content>

        </v-list-item>

      </v-list>
    </v-navigation-drawer>

  </div>
</template>

<script>
import axios from 'axios';
import { bus } from '@/main';

export default {

  data: () => ({

    drawerMobileMenu: false,

    errorExist: false,

    items: [
      {
        title: "Dashboard",
        url: "/Dashboard",
        icon: "mdi-view-dashboard"
      },
      {
        title: "Pengurusan Pengguna",
        url: "/PengurusanPengguna",
        icon: "mdi-account-group"
      },
      {
        title: "Pengurusan Tetapan Pentadbir",
        url: "/PengurusanTetapanPentadbir",
        icon: "mdi-account-wrench"
      },
      {
        title: "Pengurusan Aduan",
        url: "/PengurusanAduan",
        icon: "mdi-phone-message-outline"
      },
      {
        title: "Pengurusan E-mel",
        url: "/PengurusanEmel",
        icon: "mdi-email-mark-as-unread"
      },
      {
        title: "Pengurusan Permohonan Data",
        url: "/PengurusanPermohonanData",
        icon: "mdi-folder-file-outline"
      },
      {
        title: "Pengurusan Analisis Makmal",
        url: "/PengurusanAnalisisMakmal",
        icon: "mdi-microscope"
      },
      {
        title: "Pengurusan Pemantauan Projek",
        url: "/PengurusanPemantauan",
        icon: "mdi-monitor"
      },
      {
        title: "Audit Trail",
        url: "/AuditTrail",
        icon: "mdi-post"
      },
      {
        title: "Penjanaan Laporan",
        url: "/Laporan",
        icon: "mdi-file-sign"
      },
    ],

    dataListNegeri: [],
    arrayUserBaru: [],
    arrayAduanBaru: [],
    
  }),

  mounted() {
    this.setAccessModToButtonDisplay();
    this.getAllDropdowns();
    this.getCountNotiPengurusanPengguna();
  },

  methods: {
      
    openMenuAdmin(){
      this.drawerMobileMenu = true;
    },

    setAccessModToButtonDisplay(){

      let arrayAccessModule = this.$store.getters.user.userdetail2.adminDescription.accessmodul;
      let jenisPengguna = this.$store.getters.user.userdetail2.adminDescription.jenispengguna;
      let listItems = this.items;
      listItems.shift();
      let listDisplay = [];

      // console.log(listItems);
      // console.log(arrayAccessModule);

      if(jenisPengguna == "Pentadbir Sistem"){
        for(let i in listItems){
          listDisplay.push(listItems[i]);
        }
      }
      else{
        listItems.splice(1, 1);
        for(let i in arrayAccessModule){
          for(let x in listItems){
            if(arrayAccessModule[i] == true){
              if(x == i){
                listDisplay.push(listItems[x]);
              }
              
            }
          }
        }
      }
      

      listDisplay.unshift({
        title: "Dashboard",
        url: "/Dashboard",
        icon: "mdi-view-dashboard"
      })

      this.items = listDisplay;

      // console.log(this.items);

    },

    getAllDropdowns(){

        this.dataListNegeri = [];
        this.dataListBencana = [];

        axios.get(this.vueUrl + 'data/alldropdowns', {
            headers: {
                'Authorization': 'Bearer ' + this.$store.getters.token,
            }
        })
        .then((response) => {          
          let data = response.data

          this.dataListNegeri = data['states'];

          this.getCountNotiPengurusanAduan();


        })
        .catch(error => {
            console.log(error);
        })

      },

      getCountNotiPengurusanPengguna(){

        this.arrayUserBaru = [];

        axios.get(this.vueUrl + 'users/all',
        {
            headers: {
                Authorization: "Bearer " + this.$store.getters.user.token,
            },
        })
        .then((response) => {
            let data = response.data;
            // console.log(data);
            let arrangeArray = [];
            for(let i in data){
              if(data[i].statuspengguna == "BARU"){
                arrangeArray.push(data[i]);
              }
            }

            // Filter table based on login as PTJ mana
            let MyRegion = this.$store.getters.user.userdetail2.adminDescription.negeri;

            if(MyRegion != ""){
              for(let i in arrangeArray){
                for(let x in arrangeArray[i].negeri.split(",")){
                  for(let z in MyRegion.split(",")){
                    if(arrangeArray[i].negeri.split(",")[x].includes(MyRegion.split(",")[z])){
                      this.arrayUserBaru.push(arrangeArray[i]);
                    }
                  }
                }
              }
            }
            else{
              this.arrayUserBaru = arrangeArray;
            }

            // console.log(this.arrayUserBaru.length);

        })
        .catch((error) => {
            // console.log(error.response);

            if(error.response.status == 401){

              bus.$emit('popupMessage',{
                  result: "error",
                  icon: "mdi-account-network-off",
                  title: "Unauthorized",
                  text: "Akaun ini tidak mendapat kebenaran untuk mengakses laman ini.",
                  nota: "jumpToLogout"
              });

            }
            else if(error.response.status == 500){

              bus.$emit('popupMessage',{
                  result: "error",
                  icon: "mdi-server-network-off",
                  title: "Internal Server Error",
                  text: "HTTP 500 Internal Server Error.",
                  nota: "jumpToLogout"
              });

            }

        });

      },

      getCountNotiPengurusanAduan(){

        let currentYear = new Date().getFullYear();
        this.arrayAduanBaru = [];

        axios.get(this.vueUrl + 'complain/all?startdate='+currentYear+'-01-01&enddate='+currentYear+'-12-31', {
            headers: {
                'Authorization': 'Bearer ' + this.$store.getters.token,
            }
        })
        .then((response) => {          
          let data = response.data

          // console.log(data);

          for(let i in data){
            for(let x in this.dataListNegeri){
              // console.log(this.dataListNegeri[x].stateid);
              if(this.dataListNegeri[x].stateid == data[i].stateid){
                data[i]["negeri"] = this.dataListNegeri[x]['statename'];
              }
            }
          }

          let tempData = [];
          for(let i in data){
            if(data[i]['statusverify'] == 'PENDING'){
              tempData.push(data[i]);
            }
          }

          // console.log(tempData);



          // Filter table based on login as PTJ mana
          let MyRegion = this.$store.getters.user.userdetail2.adminDescription.negeri;
          // console.log(MyRegion.split(","));

          // console.log(tempData);

          if(MyRegion != ""){
            
            for(let i in tempData){
              if(tempData[i].negeri != null){
                for(let x in tempData[i].negeri.split(",")){
                  for(let z in MyRegion.split(",")){
                    if(tempData[i].negeri.split(",")[x].includes(MyRegion.split(",")[z])){
                      this.arrayAduanBaru.push(tempData[i]);
                    }
                  }
                }
              }
            }
          }
          else{
            this.arrayAduanBaru = tempData;
          }

          // console.log(this.arrayAduanBaru.length);

        })
        .catch(error => {
            console.log(error);
            this.loadingTableInbox = false;
        })

      },

  },

  computed: {
    notiPengurusanPengguna(){
      let count = this.arrayUserBaru.length
      return count;
    },
    notiPengurusanAduan(){
      let count = this.arrayAduanBaru.length
      return count;
    }
  },

  created (){
    bus.$on('triggerLeftPanelAdmin', (data) => {

      if(data == null){

        this.getCountNotiPengurusanPengguna();
        this.getCountNotiPengurusanAduan();

      }
      else if(data == "error"){

        this.errorExist = true;

      }
      else if(data == "success"){

        this.errorExist = false;

      }
      
    })
  },

};
</script>

<style lang="scss">
@import '@/assets/styles/main.css';

.admin-header-vue{
  z-index: 50 !important;
}

.admin-header-vue > div{
  background: #68a0b7 !important;
}

.background-mobile-menu-panel{
  background-image: url("~@/assets/img/wallpaper/left-panel1.jpg") !important;
  background-size:cover;
  background-repeat: round;
  width: 100%;
  height: 100%;
  // height: auto;
  top: 0;
  left: 0;
}

// .background-mobile-menu-panel > .v-navigation-drawer__content{
  // height: auto !important;
// }

.v-navigation-drawer--bottom.v-navigation-drawer--is-mobile{
  max-height: 100vh;
}

</style>